import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit, half } = measures

// Simplified select styles to avoid Symbol-related errors
export const select = {}

export const control = css`
  &:disabled {
    background-color: transparent;
  }
  font-size: 10px;
  font-family: Montserrat, Arial, Helvetica, sans-serif;
`

export const dropdownControl = css`
  width: 180px;
  &:disabled {
    background-color: transparent;
  }
  font-size: 10px;
  font-family: Montserrat, Arial, Helvetica, sans-serif;
`

export const row = css`
  display: flex;
  align-items: center;
  min-height: ${8 * unit}px;
  ${MQ.PHONES} {
    justify-content: space-between;
  }

  & label {
    min-width: ${14 * unit}px;
    margin-bottom: ${2 * unit}px;
  }
`

export const rowWithToggle = css`
  display: flex;
  align-items: center;
  min-height: ${8 * unit}px;

  & label {
    min-width: ${14 * unit}px;
    margin-bottom: ${9 * half}px;
    ${MQ.PHONES} {
      margin-right: ${4 * unit}px;
    }
  }
`
